import { render, staticRenderFns } from "./github-copilot.vue?vue&type=template&id=8427fcc8&scoped=true&"
import script from "./github-copilot.vue?vue&type=script&lang=js&"
export * from "./github-copilot.vue?vue&type=script&lang=js&"
import style0 from "./github-copilot.vue?vue&type=style&index=0&id=8427fcc8&prod&lang=css&"
import style1 from "./github-copilot.vue?vue&type=style&index=1&id=8427fcc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8427fcc8",
  null
  
)

export default component.exports